var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activeTab == 'general')?_c('div',{staticClass:"card-footer",class:{ 'card-footer--body': _vm.inBody }},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col text-center"},[_c('LoaderedButton',{attrs:{"type":"submit","clickHandler":_vm.submitHandler,"btnClasses":"btn btn-primary","content":_vm._f("translate")('Save')}})],1)])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af4dd960","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/stages/Widgets/SettingsFooter.vue
// module id = rQHK
// module chunks = 1 2